/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Kanban_View_AriaInputs */



/**
* | output |
* | --- |
* | "Kanban view" |
*
* @param {Explorer_Display_Kanban_View_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_kanban_view_aria = /** @type {((inputs?: Explorer_Display_Kanban_View_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Kanban_View_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vue kanban")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kanban-Ansicht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vista Kanban")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Канбан-представление")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista Kanban")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("看板视图")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カンバンビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कानबन दृश्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Visão Kanban")
	return /** @type {LocalizedString} */ ("Kanban view")
});